/**
 * Pollo Veo 3.1：generation/google/veo3-1
 * 图生：input.image 必填（仅 URL）、input.imageTail 可选（URL）、prompt 1-2000，length 4|6|8，aspectRatio 16:9|9:16，resolution 720p|1080p|4k，seed，generateAudio
 * 文生：不传 image/imageTail，其余同上
 */
import { isUrl } from './utils'

var RES_MAP = { '480p': '720p', '720p': '720p', '1080p': '1080p', '4k': '4k' }

function normalizeResolution(v) {
  if (!v) return '720p'
  var key = String(v).trim().toLowerCase()
  return RES_MAP[key] || '720p'
}

function normalizeLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 8
  if (num <= 4) return 4
  if (num <= 6) return 6
  return 8
}

function normalizeAspectRatio(v) {
  var s = (v || '16:9').replace(/：/g, ':').trim()
  return s === '9:16' ? '9:16' : '16:9'
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 2000),
    length: normalizeLength(params.videoDuration || params.length || 8),
    aspectRatio: normalizeAspectRatio(params.aspectRatio),
    resolution: normalizeResolution(params.videoRes || params.resolution),
    generateAudio: params.generateAudio !== false
  }
  var seed = params.seed != null && params.seed !== '' && params.seed !== -1 ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  if (hasImage) {
    input.image = params.referenceImage.trim()
    var tailUrl = params.imageTail || params.endFrameImage
    if (tailUrl && isUrl(tailUrl)) input.imageTail = tailUrl.trim()
  }
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
